import React from "react";
import Body from "../../components/Body";
import { useLocation, useNavigate } from "react-router-dom";
import { usePDF } from "react-to-pdf";
import { AiFillPrinter } from "react-icons/ai";
import AppButton from "../../common/AppButton";
import { Helmet } from "react-helmet-async";
import JobCompletionReportPdfTemplate from "./JobCompletionReportPdfTemplate";

function JobCompletionReportPdf() {
  const navigate = useNavigate();
  const location = useLocation();
  const { reportData } = location.state || {};

  const { toPDF, targetRef } = usePDF({
    filename: `Report - ${reportData?.organizationName} - ${reportData?.jobId}.pdf`,
    page: {
      format: "letter",
    },
  });

  const goBack = () => {
    navigate(-1);
  };

  if (!reportData) {
    return (
      <Body title="Job Completion Report" onBack={goBack} back>
        <div style={{ padding: 20, textAlign: "center" }}>
          <h3>No report data found. Please go back and try again.</h3>
          <AppButton text="Go Back" onClick={goBack} />
        </div>
      </Body>
    );
  }

  return (
    <div>
      <Helmet>
        <title>{`Report - ${reportData.organizationName} - ${reportData.jobId}`}</title>
      </Helmet>
      <Body
        onBack={goBack}
        back
        title="Job Completion Report"
        topRight={
          <div className="d-flex" style={{ gap: "10px", alignItems: "center" }}>
            <AppButton
              tooltip="Print Report"
              leftIcon={<AiFillPrinter size={25} />}
              onClick={() => toPDF()}
              text="Print"
            />
          </div>
        }
      >
        <br />
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div ref={targetRef} style={{ background: "white", boxShadow: "0 0 10px rgba(0,0,0,0.1)" }}>
            <JobCompletionReportPdfTemplate report={reportData} />
          </div>
        </div>
        <br />
        <br />
      </Body>
    </div>
  );
}

export default JobCompletionReportPdf;
